// Function to initialize the overlay functionality
function initializeOverlay() {

    /** [NIX-908] Start Country Selector Popup */
    const selectors = {
        overlayContent: '#country-picker-overlay', // Selector for the overlay content
        overlayToggle: '[data-toggle="overlay"]', // Selector for the button that toggles the overlay
        overlayClose: '.overlay__close', // Selector for the close button within the overlay
        bodyOverlayOpen: 'body', // Selector for the close button within the overlay
    };

    const overlayToggle = document.querySelectorAll(selectors.overlayToggle);
    const overlayContent = document.querySelector(selectors.overlayContent);
    const overlayClose = document.querySelector(selectors.overlayClose);
    const bodyOverlayOpen = document.querySelector(selectors.bodyOverlayOpen);

    function hideOverlay() {
        overlayContent.classList.remove('is-visible');
        bodyOverlayOpen.classList.remove('body-overlay-open');
    }

    overlayToggle.forEach(function (toggle) {
        // Add click event listener to the toggle button
        toggle.addEventListener('click', function (e) {
            // Toggle class for overlay visibility
            overlayContent.classList.toggle('is-visible');
            bodyOverlayOpen.classList.add('body-overlay-open');
        });
    });


    // Add click event listener to the close button
    overlayClose.addEventListener('click', function (e) {
        e.preventDefault();
        hideOverlay();
    });

    // Add event listener to close the overlay when ESC key is pressed
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            hideOverlay();
        }
    });
}
document.addEventListener('DOMContentLoaded', initializeOverlay);

/** End Country Selector Popup */

document.addEventListener("DOMContentLoaded", function () {
    toggleComponents();
});
// Reinitialize Toggle Components after the section is re-rendered
document.addEventListener("section:cart:load", function () {
    toggleComponents();
});

function toggleComponents() {
    const toggleComponents = document.querySelectorAll('.toggle-components');

    toggleComponents.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
            const targetId = this.getAttribute('data-target');
            const componentList = document.getElementById(targetId);

            componentList.classList.toggle('hidden');
            const toggleIcon = this.querySelector('.toggle-icon');
            toggleIcon.textContent = componentList.classList.contains('hidden') ? '▼' : '▲';
        });
    });
}
